export const ERR_CODE = {
    NULL_TOKEN: 10012,
    TOKEN_EXPIRED: 10051,
}